(function () {
  'use strict';

  var VELVETEEN_COLORS = ['Red', 'Green', 'Blue', 'Black', 'Black Walnut'];
  var WATERPROOF_COLORS = [
    'Red',
    'Green',
    'Blue',
    'Black',
    'Purple',
    'Brown',
    'Grey',
  ];

  var COLOR_HEX = {
    'Red': '#C0392B',
    'Green': '#27AE60',
    'Blue': '#2980B9',
    'Black': '#1C1C1C',
    'Purple': '#6A1B9A',
    'Brown': '#6D4C41',
    'Grey': '#757575',
    'Black Walnut': '#4A2C1E'
  };

  /* ------------------------------------------------------------------ */
  /*  Bootstrap                                                          */
  /* ------------------------------------------------------------------ */

  function init() {
    var pickers = document.querySelectorAll('[data-bbo-color-picker]');
    for (var i = 0; i < pickers.length; i++) {
      if (!pickers[i].hasAttribute('data-bbo-initialized')) {
        pickers[i].setAttribute('data-bbo-initialized', '');
        setupPicker(pickers[i]);
      }
    }
  }

  /* ------------------------------------------------------------------ */
  /*  Helpers                                                            */
  /* ------------------------------------------------------------------ */

  function escAttr(str) {
    return str.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;')
              .replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function escHtml(str) {
    return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function parseMetaColors(attr) {
    if (!attr) return null;
    try {
      var parsed = JSON.parse(attr);
      if (Array.isArray(parsed) && parsed.length > 0) return parsed;
    } catch (e) { /* ignore */ }
    return null;
  }

  /* ------------------------------------------------------------------ */
  /*  Per-picker setup                                                   */
  /* ------------------------------------------------------------------ */

  function setupPicker(picker) {
    var section = picker.closest('.shopify-section');
    if (!section) return;

    var select = picker.querySelector('[data-bbo-select]');
    if (!select) return;

    var isPreOrder = picker.hasAttribute('data-bbo-preorder');
    var errorEl = picker.querySelector('[data-bbo-error]');
    var hiddenInput = null;

    /* Read per-product color lists from metafield data attributes */
    var velvetteenMeta = parseMetaColors(picker.getAttribute('data-velveteen-colors'));
    var waterproofMeta = parseMetaColors(picker.getAttribute('data-waterproof-colors'));

    /* Build custom dropdown UI */
    var dropdown = buildCustomDropdown(picker, select);

    if (isPreOrder) {
      /* ---- pre-order mode: update CTA link with query params ---- */
      var ctaLink = section.querySelector('[data-bbo-preorder-cta]');

      var updateCtaHref = function () {
        if (!ctaLink) return;
        var baseUrl = ctaLink.getAttribute('data-base-url') || '/pages/contact';
        var productTitle = ctaLink.getAttribute('data-product-title') || '';
        var surfaceType = getSurfaceType(section) || '';
        var color = select.value || '';

        var params = [];
        if (productTitle) params.push('product=' + encodeURIComponent(productTitle));
        if (surfaceType) params.push('type=' + encodeURIComponent(surfaceType));
        if (color) params.push('color=' + encodeURIComponent(color));

        ctaLink.href = baseUrl + (params.length ? '?' + params.join('&') : '');
      };

      select.addEventListener('change', updateCtaHref);
      requestAnimationFrame(updateCtaHref);
    } else {
      /* ---- standard mode: inject hidden input into the ATC form ---- */
      var form = section.querySelector('form[data-type="add-to-cart-form"]');
      if (form) {
        hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = 'properties[Playing Surface Color]';
        hiddenInput.value = '';
        form.appendChild(hiddenInput);

        form.addEventListener(
          'submit',
          function (e) {
            if (!select.value) {
              e.preventDefault();
              e.stopPropagation();
              if (errorEl) errorEl.hidden = false;
              var trigger = picker.querySelector('[data-bbo-trigger]');
              if (trigger) trigger.focus();
              else select.focus();
            }
          },
          true
        );
      }

      /* ---- keep hidden input in sync ---- */
      select.addEventListener('change', function () {
        if (hiddenInput) hiddenInput.value = select.value;
        if (errorEl) errorEl.hidden = true;
      });
    }

    /* ---- initial colour list ---- */
    updateColors(section, select, hiddenInput, dropdown, velvetteenMeta, waterproofMeta);

    /* ---- react to variant changes ---- */
    section.addEventListener('change', function (e) {
      if (e.target.closest('variant-picker')) {
        requestAnimationFrame(function () {
          updateColors(section, select, hiddenInput, dropdown, velvetteenMeta, waterproofMeta);
          if (isPreOrder && typeof updateCtaHref === 'function') updateCtaHref();
        });
      }
    });

    section.addEventListener('variant:update', function () {
      requestAnimationFrame(function () {
        updateColors(section, select, hiddenInput, dropdown, velvetteenMeta, waterproofMeta);
        if (isPreOrder && typeof updateCtaHref === 'function') updateCtaHref();
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /*  Custom dropdown builder                                            */
  /* ------------------------------------------------------------------ */

  function buildCustomDropdown(picker, select) {
    /* Hide the native select + its wrapper */
    var selectWrapper = select.closest('.variant-option__select-wrapper');
    if (selectWrapper) selectWrapper.style.display = 'none';
    else select.style.display = 'none';

    var container = document.createElement('div');
    container.className = 'bbo-color-picker__custom';

    /* Trigger button */
    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'bbo-color-picker__trigger';
    trigger.setAttribute('data-bbo-trigger', '');
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');

    var triggerSwatch = document.createElement('span');
    triggerSwatch.className = 'bbo-color-picker__swatch';
    triggerSwatch.style.display = 'none';

    var triggerText = document.createElement('span');
    triggerText.className = 'bbo-color-picker__trigger-text';
    triggerText.textContent = 'Select a color\u2026';

    var triggerCaret = document.createElement('span');
    triggerCaret.className = 'bbo-color-picker__caret';
    triggerCaret.setAttribute('aria-hidden', 'true');
    triggerCaret.innerHTML = '<svg viewBox="0 0 10 6" width="10" height="6" focusable="false">' +
      '<path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.5" fill="none" ' +
      'stroke-linecap="round" stroke-linejoin="round"/></svg>';

    trigger.appendChild(triggerSwatch);
    trigger.appendChild(triggerText);
    trigger.appendChild(triggerCaret);

    /* Options list */
    var list = document.createElement('ul');
    list.className = 'bbo-color-picker__list';
    list.setAttribute('role', 'listbox');
    list.hidden = true;

    container.appendChild(trigger);
    container.appendChild(list);

    /* Insert into DOM */
    var variantOption = picker.querySelector('.variant-option');
    if (variantOption) {
      variantOption.appendChild(container);
    } else {
      picker.appendChild(container);
    }

    /* Toggle open/close */
    trigger.addEventListener('click', function () {
      var isOpen = !list.hidden;
      list.hidden = isOpen;
      trigger.setAttribute('aria-expanded', String(!isOpen));
    });

    /* Close on outside click */
    document.addEventListener('click', function (e) {
      if (!container.contains(e.target)) {
        list.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
      }
    });

    /* Keyboard navigation on trigger */
    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        if (list.hidden) {
          list.hidden = false;
          trigger.setAttribute('aria-expanded', 'true');
        }
        var items = list.querySelectorAll('[role="option"]');
        if (items.length > 0) items[0].focus();
      } else if (e.key === 'Escape') {
        list.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
      }
    });

    /* Keyboard navigation inside list */
    list.addEventListener('keydown', function (e) {
      var items = list.querySelectorAll('[role="option"]');
      var idx = Array.prototype.indexOf.call(items, document.activeElement);

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        if (idx < items.length - 1) items[idx + 1].focus();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        if (idx > 0) items[idx - 1].focus();
        else trigger.focus();
      } else if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        var focused = document.activeElement;
        if (focused && focused.hasAttribute('data-value')) focused.click();
      } else if (e.key === 'Escape') {
        list.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();
      }
    });

    return {
      container: container,
      trigger: trigger,
      triggerSwatch: triggerSwatch,
      triggerText: triggerText,
      list: list,
      select: select
    };
  }

  /* ------------------------------------------------------------------ */
  /*  Update dropdown options                                            */
  /* ------------------------------------------------------------------ */

  function updateDropdownOptions(dropdown, colors, currentValue) {
    var list = dropdown.list;
    var html = '';

    for (var i = 0; i < colors.length; i++) {
      var color = colors[i];
      var hex = COLOR_HEX[color] || '#ccc';
      var isSelected = color === currentValue;
      html += '<li role="option" tabindex="-1" class="bbo-color-picker__option' +
        (isSelected ? ' bbo-color-picker__option--selected' : '') +
        '" data-value="' + escAttr(color) + '" aria-selected="' + isSelected + '">' +
        '<span class="bbo-color-picker__swatch" style="background-color:' + hex + '"></span>' +
        '<span>' + escHtml(color) + '</span></li>';
    }

    list.innerHTML = html;

    /* Wire click handlers */
    var options = list.querySelectorAll('[role="option"]');
    for (var j = 0; j < options.length; j++) {
      options[j].addEventListener('click', (function (dd) {
        return function () {
          selectDropdownValue(dd, this.getAttribute('data-value'));
          dd.list.hidden = true;
          dd.trigger.setAttribute('aria-expanded', 'false');
          dd.trigger.focus();
        };
      })(dropdown));
    }

    /* Sync trigger display */
    if (currentValue && colors.indexOf(currentValue) !== -1) {
      syncTriggerDisplay(dropdown, currentValue);
    } else {
      dropdown.triggerText.textContent = 'Select a color\u2026';
      dropdown.triggerSwatch.style.display = 'none';
    }
  }

  function selectDropdownValue(dropdown, value) {
    /* Update trigger */
    syncTriggerDisplay(dropdown, value);

    /* Update option states */
    var options = dropdown.list.querySelectorAll('[role="option"]');
    for (var i = 0; i < options.length; i++) {
      var isSelected = options[i].getAttribute('data-value') === value;
      options[i].setAttribute('aria-selected', String(isSelected));
      if (isSelected) options[i].classList.add('bbo-color-picker__option--selected');
      else options[i].classList.remove('bbo-color-picker__option--selected');
    }

    /* Sync hidden native select + fire change */
    dropdown.select.value = value;
    dropdown.select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function syncTriggerDisplay(dropdown, value) {
    var hex = COLOR_HEX[value] || '#ccc';
    dropdown.triggerSwatch.style.backgroundColor = hex;
    dropdown.triggerSwatch.style.display = '';
    dropdown.triggerText.textContent = value;
  }

  /* ------------------------------------------------------------------ */
  /*  Read current "Playing Surface Type" from variant-picker DOM        */
  /* ------------------------------------------------------------------ */

  function getSurfaceType(section) {
    /* Buttons mode — radio inputs inside <fieldset> */
    var fieldsets = section.querySelectorAll('variant-picker fieldset');
    for (var i = 0; i < fieldsets.length; i++) {
      var legend = fieldsets[i].querySelector('legend');
      if (!legend) continue;

      var legendText = '';
      for (var n = 0; n < legend.childNodes.length; n++) {
        if (legend.childNodes[n].nodeType === 3) {
          legendText += legend.childNodes[n].textContent;
        }
      }
      legendText = legendText.trim();

      if (legendText === 'Playing Surface Type') {
        var checked = fieldsets[i].querySelector('input:checked');
        return checked ? checked.value : null;
      }
    }

    /* Dropdowns mode — <select> elements */
    var labels = section.querySelectorAll('variant-picker label');
    for (var j = 0; j < labels.length; j++) {
      if (labels[j].textContent.trim() === 'Playing Surface Type') {
        var forId = labels[j].getAttribute('for');
        if (!forId) continue;
        var sel = document.getElementById(forId);
        return sel ? sel.value : null;
      }
    }

    return null;
  }

  /* ------------------------------------------------------------------ */
  /*  Rebuild colour list based on surface type + metafields             */
  /* ------------------------------------------------------------------ */

  function updateColors(section, select, hiddenInput, dropdown, velvetteenMeta, waterproofMeta) {
    var surfaceType = getSurfaceType(section);
    var previousValue = select.value;

    var colors;
    if (surfaceType && surfaceType.toLowerCase().indexOf('velveteen') !== -1) {
      colors = velvetteenMeta || VELVETEEN_COLORS;
    } else {
      colors = waterproofMeta || WATERPROOF_COLORS;
    }

    /* Rebuild native select options (kept in sync for form compatibility) */
    var html = '<option value="">Select a color\u2026</option>';
    for (var i = 0; i < colors.length; i++) {
      var sel = colors[i] === previousValue ? ' selected' : '';
      html += '<option value="' + escAttr(colors[i]) + '"' + sel + '>' + escHtml(colors[i]) + '</option>';
    }
    select.innerHTML = html;

    /* If previous selection is no longer valid, reset */
    if (previousValue && colors.indexOf(previousValue) === -1) {
      select.value = '';
      if (hiddenInput) hiddenInput.value = '';
    }

    /* Update the custom dropdown */
    if (dropdown) {
      updateDropdownOptions(dropdown, colors, select.value);
    }
  }

  /* ------------------------------------------------------------------ */
  /*  Kick off                                                           */
  /* ------------------------------------------------------------------ */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
